import { render, staticRenderFns } from "./StockEditComponent.vue?vue&type=template&id=1cb25f9a"
import script from "./StockEditComponent.vue?vue&type=script&lang=js"
export * from "./StockEditComponent.vue?vue&type=script&lang=js"
import style0 from "./StockEditComponent.vue?vue&type=style&index=0&id=1cb25f9a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports